/* eslint-disable no-restricted-globals */
import moduleRegistry from '../module-registry/module-registry';
/* eslint-disable no-unused-expressions */
// eslint-disable-next-line no-undef
let $globalConfig;
if (document.querySelectorAll('.catalog').length > 0 || document.querySelectorAll('.eifu').length > 0) {
    $globalConfig = config;
}

const MAX_QUANTITY = 99;
const MIN_QUANTITY = 1;

const configinput = {
    selectors: {
        module: '.rfct-input-plus-minus',
        input: '.rfct-input__input',
        minusButton: '.rfct-input-plus-minus__button-container--minus .rfct-button',
        plusButton: '.rfct-input-plus-minus__button-container--plus .rfct-button',
    },
};

export default class InputPlusMinus {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = this._getDomElements();
        this._value = 0;
        this._min = MIN_QUANTITY;
        this._max = MAX_QUANTITY;
        this._step = 1;
    }

    _getDomElements() {
        return {
            $input: this._$rootElement.find(configinput.selectors.input),
            $minusButton: this._$rootElement.find(configinput.selectors.minusButton),
            $plusButton: this._$rootElement.find(configinput.selectors.plusButton),
        };
    }

    init() {
        if ($(configinput.selectors.minusButton) && $globalConfig.textResources.productCatalogConnectorConfig.labelForIncreaseAmount) {
            $(configinput.selectors.minusButton).attr('aria-label', $globalConfig.textResources.productCatalogConnectorConfig.labelForDecreaseAmount)
        }
        if ($(configinput.selectors.plusButton) && $globalConfig.textResources.productCatalogConnectorConfig.labelForIncreaseAmount) {
            $(configinput.selectors.plusButton).attr('aria-label', $globalConfig.textResources.productCatalogConnectorConfig.labelForIncreaseAmount)
        }
        const min = +this._elements.$input.attr('min');
        const max = +this._elements.$input.attr('max');
        const step = +this._elements.$input.attr('step');

        this._value = this.getValue();
        this._min = isNaN(min) ? MIN_QUANTITY : min;
        this._max = isNaN(max) ? MAX_QUANTITY : max;
        this._step = step || 1;
        this._addEventListeners();
        this._updateButtonState();
    }

    _addEventListeners() {
        this._addInputListener();
        this._addChangeListener();
        this._addMinusButtonClickListener();
        this._addPlusButtonClickListener();
    }

    _addInputListener() {

        // Prevent invalid characters in number input
        this._elements.$input.on('keydown', (e) => {
            if (['e', 'E', '+', '-', '.'].includes(e.key)) {
                e.preventDefault();
            }
        });

        this._elements.$input.on('input', (e) => {
            let numericValue = parseInt(e.target.value, 10);

            if (isNaN(numericValue)) {
                numericValue = this._min;
            }

            numericValue = Math.max(this._min, Math.min(numericValue, this._max));

            this._value = numericValue;
            this._elements.$input.val(numericValue);

            this._updateButtonState();
        });
    }



    _updateButtonState() {
        const isMax = this._value >= this._max;
        const isMin = this._value <= this._min;

        this._elements.$plusButton
            .prop('disabled', isMax)

        this._elements.$minusButton
            .prop('disabled', isMin)
    }



    _addChangeListener() {
        this._elements.$input.on('change', () => {
            this._triggerChange();
        });
    }

    _addMinusButtonClickListener() {
        this._elements.$minusButton.on('click', () => {
            if (this._value <= this._min) return;

            this._value = Math.max(this._value - this._step, this._min);
            this._updateValue();
        });
    }

    _addPlusButtonClickListener() {
        this._elements.$plusButton.on('click', () => {
            if (this._value >= this._max) return;

            this._value = Math.min(this._value + this._step, this._max);
            this._updateValue();
        });
    }

    _updateValue() {

        this._value = Math.max(this._min, Math.min(this._value, this._max));

        this._elements.$input.val(this._value);
        this._updateButtonState();
        this._triggerChange();
    }

    _triggerChange() {
        this._$rootElement.trigger('rfct:plusminuschange', this.getValue());
    }

    /**
     * Public setter method
     * @param {number | string} value The new value
     */
    setValue(value) {
        const parsedValue = +value;

        if (isNaN(parsedValue)) {
            return;
        }

        this._value = Math.max(Math.min(parsedValue, this._max), this._min);
        this._updateValue();
    }

    /**
     * Public getter method
     */
    getValue() {
        return +this._elements.$input.val() || this._min;
    }

    /**
     * Resets the value to the default input value
     */
    resetValue() {
        this.setValue(this._elements.$input.prop('defaultValue'));
    }
}

moduleRegistry.registerModule('InputPlusMinus', InputPlusMinus);
moduleRegistry.autoApplyModule('InputPlusMinus', configinput.selectors.module);
